import NewTable from "ui/components/NewTable";
import { ParcelaAcordo } from "core/features/acordo/typings";
import useListagemParcelaAcordoColumns from "../../hooks/useListagemParcelaAcordoColumns";

function TabelaAcordoParcela({
  isLoading,
  data,
}: {
  data: ParcelaAcordo[];
  isLoading: boolean;
}) {
  const columns = useListagemParcelaAcordoColumns();

  return (
    <>
      <NewTable<ParcelaAcordo>
        loading={isLoading}
        columns={columns}
        dataSource={data}
        pagination={false}
      />
    </>
  );
}

export default TabelaAcordoParcela;
